
import Confirmer from '@marketplace/components/forms/confirmer/confirmer.vue'
import { PUBLISH_ECOM_MUTATION } from '@marketplace/graphql/orders.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    name: 'ModalEcomDetails',

    components: {
        Confirmer,
    },

    props: {
        payload: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            isConfirmed: false,
            isbusyConfirming: false,
            errorMessage: '',
        }
    },

    methods: {
        closeModal() {
            EventBus.$emit('modal-close')
        },
        triggerSync() {
            this.errorMessage = ''
            this.isbusyConfirming = true
            this.$apollo
                .mutate({
                    mutation: PUBLISH_ECOM_MUTATION,
                    variables: {
                        id: this.payload,
                    },
                })
                .then((res) => {
                    if (res.data.retailerOrderPublish?.success) {
                        setTimeout(() => {
                            this.isConfirmed = true
                            setTimeout(() => {
                                this.closeModal()
                            }, 3000)
                        }, 500)
                    } else {
                        this.isbusyConfirming = false
                        this.isConfirmed = false
                        this.errorMessage =
                            res.data.retailerOrderPublish?.userErrors[0]?.message
                    }
                })
                .catch((res) => {
                    console.warn(res)
                })
        },
    },
}
